import { defineComponent as _defineComponent } from 'vue'
import { Dialog, DialogOverlay, TransitionChild, TransitionRoot } from "@headlessui/vue";
import { ref, watch } from "vue";
import { useScrollLock } from "@vueuse/core";


export default /*#__PURE__*/_defineComponent({
  __name: 'video-modal',
  setup(__props, { expose: __expose }) {

const open = ref(false);

const body = ref<HTMLElement>(document.body);

const bodyScrollLocked = useScrollLock(body);

__expose({ open });

watch(
    () => open.value,
    (open) => {
        if (open === false) {
            bodyScrollLocked.value = false;
        } else {
            bodyScrollLocked.value = true;
        }
    },
);

const __returned__ = { open, body, bodyScrollLocked, get Dialog() { return Dialog }, get DialogOverlay() { return DialogOverlay }, get TransitionChild() { return TransitionChild }, get TransitionRoot() { return TransitionRoot } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})